"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genWeb2RapiConfig = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _ajaxServiceGateway = require("./ajaxServiceGateway");
var _constants = require("./constants");
/**
 * Represents a fully processed Web2Rapi response. Right now
 * there is no standardized pattern for Web2Rapi reponses so it
 * is currently the same as a ProcessedAjaxServiceGatewayResponse
 */

var genWeb2RapiConfig = function genWeb2RapiConfig(config) {
  return (0, _ajaxServiceGateway.genAjaxServiceGatewayConfig)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, config), {}, {
    service: _constants.WEB2RAPI_SERVICE
  }));
};
exports.genWeb2RapiConfig = genWeb2RapiConfig;
//# sourceMappingURL=web2Rapi.js.map